var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFanfareBackground(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 833.363,
    height: 1045.669,
    viewBox: "0 0 833.363 1045.669",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fanfare-background",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3653",
    "data-name": "Path 3653",
    d: "M731.6,506c-3.9-3.9-11.5-7-16.9-7H138.2c-15.9,0-19.7,9.2-8.5,20.4l538.5,538.5c8.4,8.4,12.9,5.8,10-5.7L605.1,759.9c-2-8.2,3.2-14.9,11.6-14.9H941.6c15.9,0,19.7-9.2,8.5-20.4L731.5,506Z",
    transform: "translate(-123.268 -17.165)",
    fill: "#e9edf2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3654",
    "data-name": "Path 3654",
    d: "M348.4,368.9c3.9,3.9,11.5,7,16.9,7H941.7c15.9,0,19.7-9.2,8.5-20.4L616.8,22.1c-8.4-8.4-12.9-5.8-10,5.7l21.7,87.3c2,8.2-3.2,14.9-11.6,14.9H138.2c-15.9,0-19.7,9.2-8.5,20.4L348.3,369Z",
    transform: "translate(-123.268 -17.165)",
    fill: "#e9edf2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFanfareBackground);
export default __webpack_public_path__ + "static/media/fanfare-background.d23cf0be2e1d44f3e8000e1436437c85.svg";
export { ForwardRef as ReactComponent };